import { action, observable, computed } from "mobx";
import { post } from "../../services/ajax-calls.service";


class MedicalDiagnosisStore {

    @observable diagnosis = []
    @observable diagnosis_details = {}
    @observable diagnosis_claims = []
    @observable url = "/api/v1/medicalActions/diagnosis";
    @observable diagnosis_count = {};
    @observable count = 0;
    @observable filterValue = "";
    // @observable tiles = 0;

    @computed get tiles() {
        return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
    }

    @computed get tiles1() {
        return parseInt(this.diagnosis_count / 25) > 0 ? parseInt(this.diagnosis_count / 25) + 1 : 0;
    }

    @action indexsortbyasc(filter) {
        this.filterValue = filter;
        if (this.diagnosis.length > 0) {

            if (filter == "short_description") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.short_description > b.short_description) return -1;
                    if (a.short_description < b.short_description) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.claims_count > b.claims_count) return -1;
                    if (a.claims_count < b.claims_count) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.participant_count > b.participant_count) return -1;
                    if (a.participant_count < b.participant_count) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }

            if (filter == "chronic_indicator") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.chronic_indicator > b.chronic_indicator) return -1;
                    if (a.chronic_indicator < b.chronic_indicator) return 1;
                    return 0
                })
            }
            
            if (filter == "deductible") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.copay) > parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) < parseInt(b.copay)) return 1;
                    return 0
                })
            }
        }
        console.log(this.diagnosis)
    }

    @action indexsortbydesc(filter) {
        this.filterValue = filter;
        if (this.diagnosis.length > 0) {

            if (filter == "short_description") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.short_description < b.short_description) return -1;
                    if (a.short_description > b.short_description) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.claims_count < b.claims_count) return -1;
                    if (a.claims_count > b.claims_count) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.participant_count < b.participant_count) return -1;
                    if (a.participant_count > b.participant_count) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }

            if (filter == "chronic_indicator") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (a.chronic_indicator < b.chronic_indicator) return -1;
                    if (a.chronic_indicator > b.chronic_indicator) return 1;
                    return 0
                })
            }
            if (filter == "deductible") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.diagnosis = this.diagnosis.sort(function (a, b) {
                    if (parseInt(a.copay) < parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) > parseInt(b.copay)) return 1;
                    return 0
                })
            }
        }
        console.log(this.diagnosis)
    }

    @action sortbyasc(filter) {
        this.filterValue = filter;
        if (this.diagnosis_claims.length > 0) {

            if (filter == "total_charges") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Charges) > parseInt(b.Total_Charges)) return -1;
                    if (parseInt(a.Total_Charges) < parseInt(b.Total_Charges)) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (a.claims_count > b.claims_count) return -1;
                    if (a.claims_count < b.claims_count) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (a.participant_count > b.participant_count) return -1;
                    if (a.participant_count < b.participant_count) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }
            if (filter == "deductible") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.copay) > parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) < parseInt(b.copay)) return 1;
                    return 0
                })
            }
        }
    }



    @action sortbydesc(filter) {
        this.filterValue = filter;
        if (this.diagnosis_claims.length > 0) {

            if (filter == "total_charges") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Charges) < parseInt(b.Total_Charges)) return -1;
                    if (parseInt(a.Total_Charges) > parseInt(b.Total_Charges)) return 1;
                    return 0
                })
            }

            if (filter == "claims_count") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (a.claims_count < b.claims_count) return -1;
                    if (a.claims_count > b.claims_count) return 1;
                    return 0
                })
            }

            if (filter == "plan_pay") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return -1;
                    if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return 1;
                    return 0
                })
            }

            if (filter == "Patient_Responsibility") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return -1;
                    if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return 1;
                    return 0
                })
            }
            if (filter == "participant_count") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (a.participant_count < b.participant_count) return -1;
                    if (a.participant_count > b.participant_count) return 1;
                    return 0
                })
            }
            if (filter == "Total_Allowed") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return -1;
                    if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return 1;
                    return 0
                })
            }
            if (filter == "deductible") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.deductible) < parseInt(b.deductible)) return -1;
                    if (parseInt(a.deductible) > parseInt(b.deductible)) return 1;
                    return 0
                })
            }
            if (filter == "coinsurance") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.coinsurance) < parseInt(b.coinsurance)) return -1;
                    if (parseInt(a.coinsurance) > parseInt(b.coinsurance)) return 1;
                    return 0
                })
            }
            if (filter == "copay") {
                this.diagnosis_claims = this.diagnosis_claims.sort(function (a, b) {
                    if (parseInt(a.copay) < parseInt(b.copay)) return -1;
                    if (parseInt(a.copay) > parseInt(b.copay)) return 1;
                    return 0
                })
            }
        }
    }


    @action getDiagnosisCount = async (data) => {
        this.count = 0;
        try {
            let response = await post(
                `${this.url}/getDiagnosisCount`,
                data
            );
            this.count = response.data.total_diagnosis;
            this.tiles =
                this.count % data.limit
                    ? parseInt(this.count / data.limit)
                    : parseInt(this.count / data.limit) + 1;


        } catch (err) {
            console.log(err);
        }
    }

    @action getDiagnosis = async (data) => {
        this.diagnosis = [];
        try {
            let response = await post(
                `${this.url}/getDiagnosis`,
                data
            );

            this.diagnosis = response.data;
        } catch (err) {
            console.log(err);
        }
    }
    @action getDiagnosisDetails = async (data) => {
        this.diagnosis_details = {};
        try {
            let response = await post(
                `${this.url}/getDiagnosisDetails`,
                data
            );

            this.diagnosis_details = response.data[0];
            
            this.diagnosis_count = (new Set(response.data[0].procedures_count.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
            // console.log(JSON.stringify(this.diagnosis_count), "PCount");

        } catch (err) {
            console.log(err);
        }
    }

    @action getDiagnosisClaims = async (data) => {
        this.diagnosis_claims = [];
        try {
            let response = await post(
                `${this.url}/getDiagnosisClaims`,
                data
            );

            this.diagnosis_claims = response.data;
            // console.log(JSON.stringify(this.diagnosis_claims));
        } catch (err) {
            console.log(err);
        }
    }

}

export default MedicalDiagnosisStore;